import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';

export const OrgDashboardInvoiceViewPageContainerLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "orgDashboard/InvoiceViewContainer" */
      './OrgDashboardInvoiceViewPageContainer.dynamic'
    ),
});
